import { Control, UseFormSetValue } from 'react-hook-form';

import { DeclineFeedbackFormData } from '../../../types';
import FieldFreeText from './FieldFreeText';

export interface ReasonInputBaseProps {
    setValue: UseFormSetValue<DeclineFeedbackFormData>;
    control: Control<DeclineFeedbackFormData, unknown, DeclineFeedbackFormData>;
}

export default function BaseInput(props: ReasonInputBaseProps) {
    return (
        <FieldFreeText { ...props } />
    );
}
